import { createFileRoute } from "@tanstack/react-router";
import { comingSoonPage } from "@/components/ComingSoon";
import { requireAuth } from "@/lib/auth-guard";

/**
 * Mutes — mirrors iOS MutesScreen. Phase B wires:
 * GET /api/v1/users/me/mutes · GET /api/v1/users/me/mute-candidates ·
 * POST/DELETE /api/v1/users/me/mutes/{user_id|family_id} with
 * duration ("Until I unmute" / 7 days / 30 days).
 * Read-side only — muting is invisible to everyone else.
 */
export const Route = createFileRoute("/mutes")({
  loader: ({ context }) => requireAuth(context.queryClient),
  component: comingSoonPage(
    "Mutes",
    "A private lens. No one sees who you've muted. Quiet a person or an Extended Family Circle for a while — or until you say otherwise. We're building this surface now.",
  ),
});
